export const workflowRoutes = {
  root: '/workflow',
  workflow: (token: string) => `/workflows/${token}` as const,
  workflowVersion: (token: string) => `/workflow/${token}/version` as const,
  taxonomyCatalog: '/workflow-taxonomy',
  workflowVersionSchemaFields: (token: string) => `/workflow/${token}/version/schema-fields` as const,
} as const;
